import { IHse as Hse, IHseReport } from '../../models/hse';
import { SingleResponseType } from '../../models/singleResponseType';

export enum ActionType {
    FETCH_HSES = 'FETCH_HSES',
    FETCH_HSES_SUCCESS = 'FETCH_HSES_SUCCESS',
    FETCH_HSES_FAIL = 'FETCH_HSES_FAIL',
    FETCH_HSE_REPORT = 'FETCH_HSE_REPORT',
    FETCH_HSE_REPORT_SUCCESS = 'FETCH_HSE_REPORT_SUCCESS',
    FETCH_HSE_REPORT_FAIL = 'FETCH_HSE_REPORT_FAIL',
    ADD_HSE = 'ADD_HSE',
    ADD_HSE_SUCCESS = 'ADD_HSE_SUCCESS',
    ADD_HSE_FAIL = 'ADD_HSE_FAIL',
    EDIT_HSE = 'EDIT_HSE',
    EDIT_HSE_SUCCESS = 'EDIT_HSE_SUCCESS',
    EDIT_HSE_FAIL = 'EDIT_HSE_FAIL',
    DELETE_HSE = 'DELETE_HSE',
    DELETE_HSE_SUCCESS = 'DELETE_HSE_SUCCESS',
    DELETE_HSE_FAIL = 'DELETE_HSE_FAIL'
}

export interface IFetchHses {
    type: ActionType.FETCH_HSES;
}
export interface IFetchHsesSuccess {
    type: ActionType.FETCH_HSES_SUCCESS;
    payload: SingleResponseType<Hse>;
}
export interface IFetchHsesFail {
    type: ActionType.FETCH_HSES_FAIL;
    payload: string | null;
}

export interface IFetchHseReport {
    type: ActionType.FETCH_HSE_REPORT;
}
export interface IFetchHseReportSuccess {
    type: ActionType.FETCH_HSE_REPORT_SUCCESS;
    payload: SingleResponseType<IHseReport>;
}
export interface IFetchHseReportFail {
    type: ActionType.FETCH_HSE_REPORT_FAIL;
    payload: string | null;
}

export interface IAddHse {
    type: ActionType.ADD_HSE;
}
export interface IAddHseSuccess {
    type: ActionType.ADD_HSE_SUCCESS;
    payload: Hse;
}
export interface IAddHseFail {
    type: ActionType.ADD_HSE_FAIL;
    payload: string | null;
}

export interface IEditHse {
    type: ActionType.EDIT_HSE;
}
export interface IEditHseSuccess {
    type: ActionType.EDIT_HSE_SUCCESS;
    payload: Hse;
}
export interface IEditHseFail {
    type: ActionType.EDIT_HSE_FAIL;
    payload: string | null;
}
export interface IDeleteHse {
    type: ActionType.DELETE_HSE;
}
export interface IDeleteHseSuccess {
    type: ActionType.DELETE_HSE_SUCCESS;
    payload: number;
}
export interface IDeleteHseFail {
    type: ActionType.DELETE_HSE_FAIL;
    payload: string | null;
}

export type Action =
    | IFetchHses
    | IFetchHsesSuccess
    | IFetchHsesFail
    | IFetchHseReport
    | IFetchHseReportSuccess
    | IFetchHseReportFail
    | IAddHse
    | IAddHseSuccess
    | IAddHseFail
    | IEditHse
    | IEditHseSuccess
    | IEditHseFail
    | IDeleteHse
    | IDeleteHseSuccess
    | IDeleteHseFail
